import Axios from 'axios';
import qs from 'qs';
import { FETCH_USER_CUSTOMER_PERMISSIONS, SUBMIT_EDIT_USER_RESPONSE, STATUS_ERR_MESSAGE, FETCH_CUSTOMER_PERMISSIONS, ADMIN_FETCH_USERS, HAS_ERRORS } from './actionTypes';
import { BASEURL2, HEADERS } from './index';

export const adminFetchUsers = (user) => dispatch => {
    // console.log('AdminActions adminFetchUsers called user: ' + JSON.stringify(user));

    try {
        const param = {'USERID': user.userid, 'ROLE_NAME': user.role_name}
        
        Axios.post(`${BASEURL2}/adminFetchUsers`, qs.stringify(param, {indices: false}), { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('AdminActions adminFetchUsers data: ' + JSON.stringify(data));
            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0){
                // console.log('AdminActions adminFetchUsers data.message: ' + JSON.stringify(data.message));
                
                dispatch({                    
                    type: FETCH_USER_CUSTOMER_PERMISSIONS,   
                    payload: []
                })    

                dispatch({
                    type: ADMIN_FETCH_USERS,
                    payload: data.message,
                }); 
                
            
                
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0){

            }
            else{
                var failedResponse = 'Fetch Users Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                }

                dispatch({
                    type: HAS_ERRORS,
                    payload: failedResponse
                })

                console.log('AdminActions adminFetchUsers failed: ' + failedResponse)
            }
        });
    } catch (error) {
        console.log('AdminActions adminFetchUser error:' + error);

        dispatch({
            type: HAS_ERRORS,
            payload: error.toString()
        })
    }
}

export const adminFetchCustomerPermissions = () => dispatch => {
    try {        
        Axios.post(`${BASEURL2}/adminFetchCustomerPermissions`, { HEADERS })
        .then( function(res){
            const { data } = res;
            // console.log('AdminActions adminFetchCustomerPermissions data: ' + JSON.stringify(data));
            if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0){
                // console.log('AdminActions adminFetchCustomerPermissions data.message: ' + JSON.stringify(data.message));
                dispatch({
                    type: FETCH_CUSTOMER_PERMISSIONS,
                    payload: data.message,
                });                
            }
            else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0){

            }
            else{
                var failedResponse = 'Fetch Customer Permission Failed'
                if(typeof(data['ERROR']) !== 'undefined'){
                    failedResponse = data['ERROR']
                }

                dispatch({
                    type: HAS_ERRORS,
                    payload: failedResponse
                })

                console.log('AdminActions adminFetchCustomerPermissions failed: ' + failedResponse)
            }
        });
    } catch (error) {
        console.log('AdminActions adminFetchCustomerPermissions error:' + error);

        dispatch({
            type: HAS_ERRORS,
            payload: error.toString()
        })
    }
}

export const fetchSubmitEditUser = (editUserSelectedState, user) => {
    return async (dispatch) => {
        try{
            let submitState = {}
            submitState['EDITUSER'] = editUserSelectedState 
            // submitState['USER'] = user
            submitState['USERID'] = user 

            console.log('AdminActions fetchSubmitEditUser submitState',submitState)
            const res = await Axios.post(`${BASEURL2}/submitEditUser`, qs.stringify(submitState, { indices: false }), { HEADERS });
            const { data } = res;
            console.log('AdminActions submitEditUser data', data);

            if(typeof(data['ERROR']) === 'undefined'&& typeof(data['message']) !== 'undefined' && Object.keys(data['message']).length > 0 ){ 
                console.log('AdminActions submitEditUser failed length', Object.keys(data['message']['FAILED_UPDATES']).length);

                if(Object.keys(data['message']['FAILED_UPDATES']).length > 0){  

                    alert(data['message']['FAILED_UPDATES']);
                }
                else{
                    console.log('AdminActions submitEditUser data message', data['message']);

                    alert(data['message']['SUCCESSFUL_UPDATES']); 

                    window.location.href='/'
                }                    
            }
            else{    
                console.log('AdminActions submitEditUser data[ERROR]: ' + JSON.stringify(data['ERROR']));     

                alert(JSON.stringify(data['ERROR']));
            } 
                   
        } catch (error){
            console.log('AdminActions fetchSubmitEditUser failed error: ' + error)

            alert(error);
            // setErrorHandler( {
            //     hasError: true,
            //     message: error.toString() //error.response.data.message
            // });            
        }  
    }
}